import React from "react";
import { cn } from "@/lib/utils";

export function BackgroundBoxes({ className, ...props }) {
	const rows = new Array(50).fill(1);
	const cols = new Array(30).fill(1);
	let index = 0;

	return (
		<div
			className={cn(
				"absolute inset-0 overflow-hidden [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_110%)]",
				className
			)}
			{...props}
		>
			<div className="absolute inset-0 -z-10">
				<div
					className="absolute inset-0"
					style={{
						backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%239C92AC' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
					}}
				/>
			</div>
			<div className="absolute inset-0 -z-10">
				{rows.map((_, i) => (
					<div
						key={`row` + i}
						className="w-full flex border-b border-white/[0.08]"
						style={{
							height: `${100 / rows.length}%`,
						}}
					>
						{cols.map((_, j) => {
							index++;
							return (
								<div
									key={`col` + j}
									className="h-full w-full border-r border-white/[0.08] relative group"
									style={{
										width: `${100 / cols.length}%`,
									}}
								>
									{index % 3 === 0 && index % 5 === 0 ? (
										<div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-purple-500/20 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
									) : null}
									{index % 7 === 0 ? (
										<div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-blue-500/20 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
									) : null}
								</div>
							);
						})}
					</div>
				))}
			</div>
		</div>
	);
}

